import React from 'react';

const PayPalWhite = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.773 10.0101C27.1195 7.79761 26.788 6.38461 25.645 5.08261H25.6435C24.433 3.70411 22.1335 3.00061 18.859 3.00061H9.89504C9.19349 3.00102 8.5966 3.512 8.48804 4.20511L4.59105 28.9701C4.58706 28.9924 4.59311 29.0152 4.60758 29.0326C4.62204 29.0499 4.64345 29.06 4.66605 29.0601H9.97304L11.368 20.2191L11.389 20.2221C11.659 19.3401 12.475 18.7191 13.42 18.7191H16.246C22.0465 18.7191 25.5775 16.2096 26.68 10.5501C26.713 10.3701 26.7445 10.1946 26.773 10.0101ZM30.5385 17.7078C30.9225 15.7383 30.8265 14.0373 30.0885 12.7173C28.5195 19.1658 23.9115 22.4703 16.8945 22.4703H14.817L13.392 31.5003H11.115L10.8525 33.1638C10.8197 33.373 10.8799 33.5861 11.0175 33.7471C11.1551 33.908 11.3563 34.0007 11.568 34.0008H16.5825C17.1761 34.0006 17.6813 33.5686 17.7735 32.9823L17.8215 32.7273L18.7665 26.7378L18.8265 26.4078C18.9187 25.8212 19.4237 25.3887 20.0175 25.3878H20.7675C25.6245 25.3878 29.4285 23.4168 30.5385 17.7078Z"
      fill="white"
    />
  </svg>
);

export default PayPalWhite;
